import React, { useCallback, useEffect, useState } from 'react';
import {
  loadProductManager,
  updateProductManager,
} from 'js/actions/product-manager-actions';
import { default as ProductManagerComponent } from '../components/ProductManager';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { denormalize } from 'normalizr';
import { useNotify } from 'js/hooks/useNotify';
import { SCHEMAS } from 'js/api/schemas';

function ProductManager({
  productManager,
  loadProductManager,
  updateProductManager,
}) {
  const { productManagerId } = useParams();
  const notify = useNotify();
  const [hasLoaded, setHasLoaded] = useState(productManager?.stats != null);

  const refreshProductManager = useCallback(
    () => loadProductManager(productManagerId),
    [loadProductManager, productManagerId]
  );

  useEffect(() => {
    async function refresh() {
      await refreshProductManager();
      setHasLoaded(true);
    }

    refresh();
  }, [refreshProductManager]);

  const handleUpdate = useCallback(
    async (values) => {
      return updateProductManager({ id: productManagerId, ...values })
        .then(() => {
          notify({
            type: 'success',
            message: 'Product manager updated successfully',
          });
          return refreshProductManager();
        })
        .catch((error) => {
          notify({
            type: 'danger',
            message: 'Failed to update product manager',
          });
          throw error;
        });
    },
    [updateProductManager, productManagerId, notify, refreshProductManager]
  );

  return (
    <ProductManagerComponent
      productManager={productManager}
      onUpdate={handleUpdate}
      hasLoaded={hasLoaded}
    />
  );
}

export default connect(
  (state, { match }) => ({
    productManager: denormalize(
      state.entities.productManagers[match.params.productManagerId],
      SCHEMAS.PRODUCT_MANAGER,
      state.entities
    ),
  }),
  {
    loadProductManager,
    updateProductManager,
  }
)(ProductManager);
